module.exports = __webpack_public_path__ + "static/media/comment-dots-dark-gray.42dc9706.svg";